import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { File } from './file';
import { SiteVendor } from './site-vendor';

export class SiteVendorFile extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static SiteVendorFileProperties: (
    | {
        property: keyof SiteVendorFile;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof SiteVendorFile;
        type: 'alias';
      }
    | {
        property: keyof SiteVendorFile;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'SiteVendorId', type: 'column', dataType: 'number' },
    { property: 'FileId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'SiteVendor', model: 'SiteVendor', type: 'association' },
    { property: 'File', model: 'File', type: 'association' }
  ];

  static {
    SiteVendorFile.SiteVendorFileProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        SiteVendorFile.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        SiteVendorFile.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        SiteVendorFile.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(SiteVendorFileObject: Partial<SiteVendorFile>) {
    super();

    SiteVendorFile.SiteVendorFileProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = SiteVendorFileObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  SiteVendorId?: number;
  FileId?: number;
  createdAt?: Date;
  updatedAt?: Date;

  SiteVendor?: SiteVendor;
  File?: File;
}
